import { NgModule, ApplicationRef } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { BootstrapModalModule } from 'ng2-bootstrap-modal';
import { ToastrModule } from 'ngx-toastr';
import { SlimLoadingBarModule } from 'ng2-slim-loading-bar';
import { NgUploaderModule } from 'ngx-uploader';
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { AppTranslationModule } from './app.translation.module';
import { DataTableModule } from 'angular2-datatable';
import { DateTimePickerModule } from 'ng-pick-datetime';
/*
* Platform and Environment providers/directives/pipes
*/
import { routing } from './app.routing';

// App is our top level component
import { App } from './app.component';
import { AppState, InternalStateType } from './app.service';
import { GlobalState } from './global.state';
import { NgaModule } from './theme/nga.module';
import { PagesModule } from './pages/pages.module';
import { ConfirmComponent } from './modals';
import { NotificationRecipientsComponent } from './modals/notification-recipients/notification-recipients.component';

import { UsersService, NotificationsService, AlertService, TransactionsService, CommentsService } from './services';

// Application wide providers
const APP_PROVIDERS = [
    AppState,
    GlobalState
];

export type StoreType = {
    state: InternalStateType,
    restoreInputValues: () => void,
    disposeOldHosts: () => void
};

/**
 * `AppModule` is the main entry point into Angular2's bootstraping process
 */
@NgModule({
    bootstrap: [App],
    declarations: [
        App,
        ConfirmComponent,
        NotificationRecipientsComponent
    ],
    imports: [ // import Angular's modules
        BrowserModule,
        BrowserAnimationsModule,
        HttpModule,
        HttpClientModule,
        RouterModule,
        ReactiveFormsModule,
        FormsModule,
        NgaModule.forRoot(),
        NgbModule.forRoot(),
        PagesModule,
        routing,
        SlimLoadingBarModule.forRoot(),
        ToastrModule.forRoot({ 
            timeOut: 3500,
        }),
        BootstrapModalModule,
        NgUploaderModule,
        MultiselectDropdownModule,
        AppTranslationModule,
        DataTableModule,
        DateTimePickerModule,
    ],
    entryComponents: [
        ConfirmComponent,
        NotificationRecipientsComponent
    ],
    providers: [ // expose our Services and Providers into Angular's dependency injection
        APP_PROVIDERS,
        UsersService,
        NotificationsService,
        AlertService,
        TransactionsService,
        CommentsService,
    ]
})

export class AppModule {
    constructor(public appState: AppState) {}
}



// WEBPACK FOOTER //
// /Users/Miroslav/Projects/Dubravica/backoffice/src/app/app.module.ts